module.exports = __webpack_public_path__ + "img/doctor-img.8323dbda.jpg";